// extracted by mini-css-extract-plugin
export default {"modalTitle":"vp_gRH4iXNtTVWP_D6eW"};